export const FORGOT_PASSWORD = {
  heading: 'Reset your password',
  subHeading: 'We will send you an email to reset your password.',
  submit: 'Submit',
  cancel: 'Cancel',
};
export const SIGNUP = {
  heading: 'Create Account',
  create: 'Create',
};
export const LOGIN = {
  heading: 'Login',
  forgot_password: 'Forgot Your Password ?',
  submit: 'Submit',
  create: 'Create Account',
};
